import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import { Route } from 'react-router-dom';
// import Aux from '../Auxiliary/Auxiliary';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer';
import Footer from '../../containers/Footer/Footer';
import classes from './Layout.module.css';
// import { faThinkPeaks } from '@fortawesome/free-brands-svg-icons';
// imported in App.js
// contain the toolbar and sidebar

class Layout extends Component {
    state = {
        showMenu: false,
        windowSrolled: false
    }

    componentDidMount = () => {
        window.addEventListener('scroll', this.handleWindowScrollY);
    }

    handleWindowScrollY = () => {
        const isSrolled = window.scrollY > 200;
        // console.log( 'PX windowSrolled', isSrolled)
        if (isSrolled !== this.state.windowSrolled) {
            this.setState({windowSrolled: isSrolled})
        }
    }

    menuToggleHandler = () => {
        this.setState((prevState) => {
            return {showMenu: !prevState.showMenu};
        });
    }

    menuClosedHandler = () => {
        this.setState({showMenu: false});
    }

    // fbButtonClickHandler = () => {
    //     console.log('LAYOUT PAGE this.props', this.props)
    // }

    render () {
        let attachClasses = [classes.Content];
        let homePage = null;

        if (this.props.location.pathname === '/') {
            homePage = true;
            attachClasses = [classes.Content, classes.HomePage]
        } else {
            homePage = false;
        }

        return (
            <div className={classes.ContentWrapper}>
            {/* <Aux> */}
                <Toolbar menuClicked={this.menuToggleHandler} windowSrolled={this.state.windowSrolled} homePage={homePage} />
                <SideDrawer 
                    toOpen={this.state.showMenu}
                    toClose={this.menuClosedHandler}
                    // subMenuClicked={this.subMenuClickedHandler}
                    // toOpenSubMenu={this.state.showSubMenu} 
                    />
                <main className={attachClasses.join(' ')}>
                    {this.props.children}
                </main>
                <Footer fbClicked={this.fbButtonClickHandler} />
            {/* </Aux> */}
            </div>
        )
    };
};

export default withRouter(Layout);

